module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/oil_stick_1k_bake.png";